import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=471a014a&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=ts&"
export * from "./Spacer.vue?vue&type=script&lang=ts&"
import style0 from "./Spacer.vue?vue&type=style&index=0&id=471a014a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a014a",
  null
  
)

export default component.exports